import React from 'react'
import PropTypes from 'prop-types'
import { UnboundAvatar, avatarColors } from 'components/common/avatar'
import ExpandableParagraph from 'components/common/expandable_paragraph'
import cssModules from 'react-css-modules'
import styles from './activity_row.less'
import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'
import { getHash } from 'shared/helpers/string_helpers'
import { getInitials } from 'shared/helpers/name_helpers'
import { Divider, BodyText } from '@paypalcorp/pp-react'

const i18n = getI18n('components/txn_row')
const i18nActivity = getI18n('components/edit_glimpse/activity')

class ActivityRow extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    note: PropTypes.string,
    amount: PropTypes.number,
    currency: PropTypes.string,
    contributor_id: PropTypes.string,
    contributor_name: PropTypes.string,
    contributor_photo: PropTypes.string,
    pending: PropTypes.bool,
    withdraw: PropTypes.bool,
    net_amount: PropTypes.number,
  }

  getAvatarBackgroundColor = () => {
    if (this.props.withdraw) return 'blue'
    if (!this.props.contributor_id) return 'white'
    const uniqueNumericId = getHash(this.props.contributor_id.toString())
    return avatarColors[uniqueNumericId % avatarColors.length]
  }

  render() {
    const amountStyleName = this.props.withdraw ? 'amount' : 'amount-positive'
    const amountSign = this.props.withdraw ? '-' : '+'
    const subjectName = this.props.withdraw
      ? i18n('txn_row.paypal_balance')
      : this.props.contributor_name
    const activityType = this.props.withdraw
      ? i18n('txn_row.transfer')
      : i18n('txn_row.contribution')
    const avatarIcon = this.props.withdraw ? 'money-out' : undefined
    return (
      <div styleName="activity-row">
        <div styleName="avatar-wrapper">
          <UnboundAvatar
            icon={avatarIcon}
            initials={getInitials(this.props.contributor_name)}
            imageUrl={this.props.contributor_photo}
            backgroundColor={this.getAvatarBackgroundColor()}
            small={true}
          />
        </div>
        <div styleName="details-wrapper">
          <BodyText strong>{subjectName}</BodyText>
          <BodyText styleName="activity-status">
            {activityType}
            {this.props.pending ? (
              <span>
                {' \u2022 '}
                {i18nActivity('activity.pending')}
              </span>
            ) : (
              ''
            )}
          </BodyText>
          {this.props.note && (
            <ExpandableParagraph lightLink={true} lightText={true} maxRows={2}>
              <BodyText styleName="activity-note"> {this.props.note} </BodyText>
            </ExpandableParagraph>
          )}
        </div>
        <div styleName={amountStyleName}>
          {amountSign}
          {formatMoney(this.props.currency, this.props.net_amount)}
        </div>
        <Divider secondary />
      </div>
    )
  }
}

export default cssModules(ActivityRow, styles)
